import React from "react";
import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import { LevelFormValues } from "src/models/Level.model";

type Props = {
  formikProps: FormikProps<LevelFormValues>;
  onClose: () => void;
  formType: "ADD" | "EDIT";
};

const LevelForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium">
          {formType === "ADD" ? "Add Level" : "Update Level"}{" "}
        </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        <div>
          <ATMTextField
            name="levelName"
            value={values.levelName}
            required
            onChange={(e) => {
              setFieldValue("levelName", e.target.value);
            }}
            label="Level Name"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMTextField
            name="levelCode"
            value={values.levelCode}
            required
            onChange={(e) => {
              setFieldValue("levelCode", e.target.value);
            }}
            label="Level Code"
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default LevelForm;
